import React, { useContext, useEffect, useState } from 'react';
import styles from './Dashboard.module.css';
import Card from './Card';
import { useNavigate } from 'react-router-dom';
import { DEVICES_PATH, USERS_PATH } from '../../router/RouteConstants';
import { useAuthenticate } from '../../hooks';
import { API } from '../../services';
import AIEduSpinner from '../../components/Spinner/AIEduSpinner';
import { Context } from '../../context/Context';
import { ROLE_USER } from '../../utils/Constants';

const Dashboard = () => {
    const navigate = useNavigate();
    const { accountInfo } = useAuthenticate();
    const { organizations, place, account } = accountInfo ?? {};
    const { userName } = account ?? {};
    const { placeId } = place ?? {};
    const { organizationId } = organizations?.[0] ?? {}; // assuming there is only one organization for now. This can be changed later.
    const [dashboardDetails, setDashboardDetails] = useState({});
    const [loading, setLoading] = useState(false);
    const {
        refreshMap,
        setIsAddDeviceVisible,
        setIsAddUserVisible,
        setDefaultAccessType,
    } = useContext(Context);

    useEffect(() => {
        setIsAddUserVisible(false);
        setIsAddDeviceVisible(false);

        setLoading(true);
        API.getDashboardDetails(organizationId, placeId)
            .then(({ data }) => {
                setDefaultAccessType(data?.defaultRole || ROLE_USER);
                setDashboardDetails(data);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [refreshMap.dashboard]);

    const handleAddUser = () => {
        setIsAddUserVisible(true);
        navigate(USERS_PATH);
    };

    const handleAddDevice = () => {
        setIsAddDeviceVisible(true);
        navigate(DEVICES_PATH);
    };

    return (
        <div className={styles.dashboard}>
            {loading && <AIEduSpinner />}
            <div
                className={styles.dashboard_header}
                title={dashboardDetails?.organizationName}
            >
                {dashboardDetails?.organizationName}
            </div>
            <div className={styles.dashboard_subheader}>
                {`Hi! ${userName}`}
            </div>

            <div className={styles.card_container}>
                <Card
                    headerText='Users'
                    activeCount={18}
                    totalCount={dashboardDetails?.users || 0}
                    redirectCallback={handleAddUser}
                    navigationRoute={USERS_PATH}
                />
                <Card
                    headerText='Devices'
                    activeCount={45}
                    totalCount={dashboardDetails?.screens || 0}
                    redirectCallback={handleAddDevice}
                    navigationRoute={DEVICES_PATH}
                />
            </div>
        </div>
    );
};

export default Dashboard;
